import './layout.scss';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueTableOfContent from '@ui-common/vue-table-of-content';
import macc from '../../modules/MACC/macc';
import mevp from '../../modules/MEVP/mevp';
import mhap from '../../modules/MHAP/mhap.vue';
import mksz from '../../modules/MKSZ/mksz';
import mtab from '../../modules/MTAB/mtab';
import mrbt from '../../modules/MRBT/mrbt';
import mjbl from '../../modules/MJBL/mjbl.vue';
import mdtb from '../../modules/MDTB/mdtb';
import mtbl from '../../modules/MTBL/mtbl';
import mstb from '../../modules/MSTB/mstb';
import mubt from '../../modules/MUBT/mubt';
import moav from '../../modules/MOAV/moav';
import mife from '../../modules/MIFE/mife';
import mfsh from '../../modules/MFSH/mfsh.vue';
import masd from '../../modules/MASD/masd.vue';
import layoutBase from '../layout-base';
import videoPlayer from '../../common/components/video-player/video-player.vue';

Vue.use(VueRouter);
Vue.component('macc', macc);
Vue.component('mdtb', mdtb);
Vue.component('mtbl', mtbl);
Vue.component('mstb', mstb);
Vue.component('mubt', mubt);
Vue.component('mtab', mtab);
Vue.component('mevp', mevp);
Vue.component('mfsh', mfsh);
Vue.component('mhap', mhap);
Vue.component('mksz', mksz);
Vue.component('mrbt', mrbt);
Vue.component('mjbl', mjbl);
Vue.component('moav', moav);
Vue.component('mife', mife);
Vue.component('masd', masd);
Vue.component('video-player', videoPlayer);
Vue.component('vue-table-of-content', VueTableOfContent);

/* eslint-disable no-new*/
new Vue({
	el: '[data-layout-id=AV9PK-app]',
	extends: layoutBase
});
/* eslint-enable*/
